var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c("search-customer", {
            staticClass: "search-customer",
            on: { inputData: _vm.inputSearchCustomer }
          }),
          _vm._v(" "),
          _c("customer-table", {
            attrs: {
              "customer-foundt-list": _vm.items,
              "has-search": _vm.hasSearch,
              "search-params": _vm.searchParams
            },
            on: { hasNotSearch: _vm.hasNotSearch }
          }),
          _vm._v(" "),
          _c("message-special-situation", {
            attrs: { collapsableMessage: true }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }